<template>
  <div class="w-full max-w-[448px] mx-auto mt-32 px-16 sm:px-0 pb-32">
    <h1 class="text-h2 mb-16">Applications</h1>
    <Tabs
      v-model="tabSelectionIndex"
      :tabs="[
        { title: 'Active', parenthesesNumber: activeApplicationsCount },
        { title: 'Closed', parenthesesNumber: closedApplicationsCount },
      ]"
      class="mb-24"
      :tabListClasses="['grid-cols-2', 'md:grid-cols-none']"
    />
    <router-view />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Tabs from '@/components/tabs/Tabs.vue';
import { FETCH_PROVIDER_APPLICATION_COUNTS } from '@/graphql/account/queries';

export default defineComponent({
  name: 'ProviderApplications',
  components: { Tabs },
  apollo: {
    applicationCounts: {
      query: FETCH_PROVIDER_APPLICATION_COUNTS,
      update(data) {
        return data.viewer || null;
      },
    },
  },
  data(): { tabSelectionIndex: number; applicationCounts: any } {
    return { tabSelectionIndex: 0, applicationCounts: null };
  },
  computed: {
    activeApplicationsCount(): number | null {
      return this.applicationCounts?.activeApplications?.totalCount;
    },
    closedApplicationsCount(): number | null {
      return this.applicationCounts?.closedApplications?.totalCount;
    },
  },
  watch: {
    $route: {
      handler(route: { name?: string }) {
        const routeToIndexMap: Record<string, number> = {
          'provider-applications-active': 0,
          'provider-applications-closed': 1,
        };
        const index = route.name ? routeToIndexMap[route.name] : undefined;
        if (index !== undefined && this.tabSelectionIndex !== index) {
          this.tabSelectionIndex = index;
        }
      },
      immediate: true,
    },
    tabSelectionIndex(newIndex: number): void {
      const routeNames = ['provider-applications-active', 'provider-applications-closed'];
      const routeName = routeNames[newIndex];
      if (routeName && this.$route.name !== routeName) {
        this.$router.push({ name: routeName });
      }
    },
  },
});
</script>
